import React, { useEffect, useState } from "react";

import {
  ActionList,
  ActionListGroup,
  ActionListItem,
  Button,
  Content,
  ContentVariants,
  Hero,
  Label
} from "@patternfly/react-core";

import "../../home/heroes/HomeHero.css";
import { getFacebookPostTitle } from "../utils/getFacebookPostTitle";
import { renderFacebookText } from "../utils/renderFacebookText";

import { getHeroGradient } from "../../../config/hero";

const SocialHero = ({
  post,
  gradientVariant = "blue",
  useGradient = false,
  carouselControls
}) => {
  
  const [imageOrientation, setImageOrientation] =
    useState("landscape");

  const heroGradient = getHeroGradient(gradientVariant);

  const socialPost = post || {
    title: "Zobacz, co dzieje się w naszej szkole",
    excerpt:
      "Aktualności, wydarzenia, sukcesy uczniów i relacje z życia szkoły.",
    url: 'https://www.facebook.com/',
    profileUrl: 'https://www.facebook.com/',
    image: {
      src: "/assets/images/school-site/hero/facebook-hero-bg.png",
      alt: "Aktualności szkoły na Facebooku"
    }
  };

  const {
    excerpt = "",
    publishedAt,
    url,
    profileUrl,
    image: postImage,
    hero_media: heroMedia,
    showHeroImage = true
  } = socialPost;

  const image = {
    ...postImage,
    type:
      postImage?.type ||
      heroMedia?.type ||
      "image",
    videoSrc:
      postImage?.videoSrc ||
      postImage?.video_src ||
      heroMedia?.videoSrc ||
      heroMedia?.video_src ||
      null,
    isAnimated:
      postImage?.isAnimated ||
      heroMedia?.type === "video"
  };

  const fallbackImageSrc =
  "/assets/images/school-site/hero-social/facebook-hero-bg.png";

  const isFacebookVideoThumbnail =
    typeof image?.src === "string" &&
    image.src.includes("/t15.5256-10/");

  const displayedImage = {
    ...image,
    src: isFacebookVideoThumbnail
      ? fallbackImageSrc
      : image?.src
  };

  const getFacebookHashtags = (text = "") => {
    return text.match(/#[\p{L}\p{N}_-]+/gu) || [];
  };
  const hashtags = getFacebookHashtags(excerpt);

  const displayedHashtags = hashtags.slice(0, 3);
  // const displayedHashtags = hashtags.slice(0, 1);
  const title = getFacebookPostTitle(socialPost);



  const publishDate = publishedAt
    ? new Date(publishedAt).toLocaleDateString("pl-PL", {
        day: "numeric",
        month: "long",
        year: "numeric"
      })
    : "";
  
  const handleMediaLoad = (event) => {
    const width =
      event.currentTarget.videoWidth ||
      event.currentTarget.naturalWidth;

    const height =
      event.currentTarget.videoHeight ||
      event.currentTarget.naturalHeight;

    if (!width || !height) {
      return;
    }

    const ratio = width / height;

    if (ratio < 0.9) {
      setImageOrientation("portrait");
      return;
    }

    if (ratio <= 1.1) {
      setImageOrientation("square");
      return;
    }

    setImageOrientation("landscape");
  };
  
  useEffect(() => {
    setImageOrientation("landscape");
  }, [displayedImage?.src]);

  return (
      <Hero
        isGlass
        className="school-home-hero school-social-hero"
        bodyWidth="100%"
        bodyMaxWidth="100%"
        {...(
          useGradient
            ? {
                gradientLight: heroGradient.light,
                gradientDark: heroGradient.dark
              }
            : {}
        )}
      >
        <div className="school-home-hero__layout">
          <div className="school-home-hero__content">
            <div className="school-home-hero__meta">
              <Label
                variant="outline"
                color="blue"
              >
                Facebook
              </Label>

              {publishDate && (
                <Content component={ContentVariants.small}>
                  {publishDate}
                </Content>
              )}
            </div>

            <Content
              component={ContentVariants.h1}
              className="school-home-hero__title"
            >
              {title}
            </Content>

            {excerpt && (
              <Content
                component={ContentVariants.p}
                className="school-home-hero__excerpt"
              >
                {renderFacebookText(excerpt)}
              </Content>
            )}

            <div className="school-home-hero__spacer" />

            <ActionList>
              <ActionListGroup>
                {url && (
                  <ActionListItem>
                    <Button
                      component="a"
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="primary"
                    >
                      Zobacz post
                    </Button>
                  </ActionListItem>
                )}
              </ActionListGroup>
            </ActionList>
          </div>
          
          {showHeroImage && displayedImage?.src && (
            <a
              href={url || displayedImage.src}
              target="_blank"
              rel="noopener noreferrer"
              className={[
                "school-home-hero__media",
                `school-home-hero__media--${imageOrientation}`
              ].join(" ")}
              aria-label={`Zobacz post na Facebooku: ${title}`}
            >
              <img
                src={displayedImage.src}
                alt={displayedImage.alt || title}
                className="school-home-hero__image"
                onLoad={handleMediaLoad}
              />

              {isFacebookVideoThumbnail &&
                displayedHashtags.length > 0 && (
                  <div className="school-home-hero__image-tags">
                    {displayedHashtags.map((hashtag) => (
                      <span
                        key={hashtag}
                        className="school-home-hero__image-tag"
                      >
                        {hashtag}
                      </span>
                    ))}
                  </div>
                )}
            </a>
          )}
        </div>
        {carouselControls && (
          <div className="school-home-hero__footer">
            {carouselControls}
          </div>
        )}
      </Hero>
  );
};

export default SocialHero;